import { companyInfo } from "@/config/constants";

export function LeftPanel() {
  return (
    <div className="hidden lg:flex lg:flex-col bg-gradient-to-br from-green-900 via-green-800 to-green-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full">
          <div className="grid grid-cols-8 gap-4 h-full opacity-20">
            {Array.from({ length: 64 }).map((_, i) => (
              <div
                key={i}
                className="bg-white/5 rounded-lg"
                style={{
                  animationDelay: `${i * 0.1}s`,
                  animation: "pulse 4s ease-in-out infinite"
                }}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="relative z-10 flex flex-col justify-between h-full p-12">
        {/* Header */}
        <div>
          <div className="flex items-center gap-3 mb-2">

            <div>
              <img src="/assets/logo_text.png" alt="logo" className="h-8 " />
            </div>
          </div>
          <p className="text-blue-200 text-sm font-medium">{companyInfo.description}</p>
        </div>

        {/* Features */}
        <div className="space-y-8">
          <img src="/assets/login.png" alt="login" className="w-full h-full" />
        </div>

        {/* Footer */}
        <div className="text-green-300 text-sm">
          © 2025 {companyInfo.name}
        </div>
      </div>
    </div>    
  );
}